import { render, staticRenderFns } from "./UserPublicAvatar.vue?vue&type=template&id=2d4b1fee&scoped=true&"
import script from "./UserPublicAvatar.vue?vue&type=script&lang=js&"
export * from "./UserPublicAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserPublicAvatar.vue?vue&type=style&index=0&id=2d4b1fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b1fee",
  null
  
)

export default component.exports